export enum VehicleOrigin {
	COMMISSION_CAR = "COMMISSION_CAR",
	FACTORY_ORDER = "FACTORY_ORDER",
	LEASE_RETURN = "LEASE_RETURN",
	PURCHASE_FROM_COMMERCIAL_OWNER = "PURCHASE_FROM_COMMERCIAL_OWNER",
	PURCHASE_FROM_IMPORTER = "PURCHASE_FROM_IMPORTER",
	PURCHASE_FROM_OTHER_PORSCHE_CENTER = "PURCHASE_FROM_OTHER_PORSCHE_CENTER",
	PURCHASE_FROM_PRIVATE_OWNER = "PURCHASE_FROM_PRIVATE_OWNER",
	PURCHASE_FROM_WERKSWAGEN = "PURCHASE_FROM_WERKSWAGEN",
	TRADE_IN_FOR_NEW_CAR = "TRADE_IN_FOR_NEW_CAR",
	TRADE_IN_FOR_USED_CAR = "TRADE_IN_FOR_USED_CAR",
}
